import * as adAction from "./adAction";
const adManageMap = new Map();
export const on = (key, fn) => {
    adManageMap.set(key, async (option) => {
        return await fn(option);
    });
};
export const emit = (key, option) => {
    return new Promise(async (resolve, reject) => {
        const fn = adManageMap.get(key);
        if (fn) {
            try {
                resolve(await fn(option));
            }
            catch (err) {
                reject(err);
            }
        }
        else {
            reject("no key");
        }
    });
};
const bootstarp = () => {
    for (const key in adAction) {
        on(key, adAction[key]);
    }
};
bootstarp();
//# sourceMappingURL=adManage.js.map